/* eslint-disable @typescript-eslint/no-explicit-any */

import { Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/service/auth.service';
import { MatSidenav } from '@angular/material/sidenav';
import { RoutingService } from 'src/app/service/routing.service';
import { ConfigService } from 'src/app/service/config.service';
import { BookmarkApiService } from 'src/app/shared/services/customer-api/bookmark-api.service';
import { MaintenanceApiService } from 'src/app/shared/services/customer-api/maintenance-api.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-cockpit',
  templateUrl: './cockpit.component.html',
  styleUrls: ['./cockpit.component.scss'],
})
export class CockpitComponent {
  params: any;
  impersonate: any;
  status: any;
  statusObject: any;
  @ViewChild('sidenav') public sidenav: MatSidenav;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public auth: AuthService,
    public routing: RoutingService,
    public config: ConfigService,
    private bookmarkApi: BookmarkApiService,
    private maintenanceApi: MaintenanceApiService,
  ) {
    this.route.queryParams.subscribe((params) => {
      this.params = params;
    });

    this.impersonate = false;

    if (this.config.appConfig.setup.useStorage) {
      if (
        this.params.impersonate ||
        (localStorage.getItem('impersonate') !== undefined &&
          localStorage.getItem('impersonate') === this.auth.userdata?.email)
      ) {
        this.impersonate = true;
      }
    }

    this.maintenanceApi.getStatus().subscribe((result) => {
      this.statusObject = result;

      if (Object.prototype.hasOwnProperty.call(this.statusObject, 'message')) {
        this.status = true;
      } else {
        this.status = false;
      }
    });

    if (this.config.appConfig.setup.useStorage) {
      this.bookmarkApi.getStars().subscribe((result) => {
        localStorage.setItem('news_curation', result);
      });
    }

    document.addEventListener('fullscreenchange', () => {
      if (!document.fullscreen || !(document.fullscreenElement !== null)) {
        router.navigate([], {
          queryParams: { fullscreen: null },
          queryParamsHandling: 'merge',
          replaceUrl: true,
        });
      } else {
        router.navigate([], {
          queryParams: { fullscreen: true },
          queryParamsHandling: 'merge',
          replaceUrl: true,
        });
      }
    });
  }

  closeStatus() {
    this.status = false;
  }
}
